import React, { useEffect, useState } from 'react';
import { ClockIcon, SproutIcon } from 'lucide-react';
export function UrgencyBanner() {
  const [time, setTime] = useState({
    h: 22,
    m: 51,
    s: 46
  });
  useEffect(() => {
    const timer = window.setInterval(() => setTime(current => {
      if (current.s > 0) return {
        ...current,
        s: current.s - 1
      };
      if (current.m > 0) return {
        h: current.h,
        m: current.m - 1,
        s: 59
      };
      return {
        h: Math.max(current.h - 1, 0),
        m: 59,
        s: 59
      };
    }), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => String(value).padStart(2, '0');
  return <aside className="sticky top-0 z-50 overflow-hidden border-b border-brand-yellow/40 bg-[#24704C] py-2.5 text-brand-cream shadow-md" data-id="element-310" data-mp="3b8iv2ec2k8ag">
      <div className="ticker-track flex w-max items-center whitespace-nowrap text-xs font-medium md:text-sm" data-id="element-311" data-mp="1bwzm3zqrn00s">
        {[0, 1].map(duplicate => <div key={duplicate} className="flex shrink-0 items-center gap-5 px-4" data-id="element-312" data-mp="27eq3i0o7hus1">
            <span className="inline-flex items-center gap-2" data-id="element-313" data-mp="27gj9reuwqczi">
              <ClockIcon className="h-4 w-4 text-brand-yellow" data-id="element-314" data-mp="22n81d9ag5o5h" />
              Precio de lanzamiento cierra en{' '}
              <strong className="rounded bg-white/10 px-2 py-0.5 font-mono text-brand-yellow" data-id="element-315" data-mp="1xp6hwn93zmth">
                {format(time.h)}:{format(time.m)}:{format(time.s)}
              </strong>
            </span>
            <span className="h-4 w-px bg-brand-cream/30" aria-hidden="true" data-id="element-316" data-mp="2qcstoishpxrf" />
            <span className="inline-flex items-center gap-2" data-id="element-317" data-mp="2lfsoea3gsz1d">
              <SproutIcon className="h-4 w-4 text-brand-yellow" data-id="element-318" data-mp="2gev8k45xgh31" />
              <strong className="text-brand-yellow" data-id="element-319" data-mp="2ghhe5y99cmim">94%</strong> de cupos
              tomados
            </span>
            <span className="h-4 w-px bg-brand-cream/30" aria-hidden="true" data-id="element-320" data-mp="1509ajf6frafi" />
            <a href="#pricing" className="rounded-full border border-brand-yellow/60 px-3 py-1 font-bold text-brand-yellow transition-colors hover:bg-brand-yellow hover:text-brand-deep focus:outline-none focus:ring-2 focus:ring-brand-cream" data-id="element-321" data-mp="14y4ww5iqix21">
              Ver sistema
            </a>
            <span className="h-4 w-px bg-brand-cream/30" aria-hidden="true" data-id="element-322" data-mp="17ee6apeeke3g" />
          </div>)}
      </div>
    </aside>;
}